module.exports = "https://static.energy5.com/_next/static/images/slide4-e306113872acd7f1e2c90d486c95520d.png";